var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcLetter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 11,
  fill: "none",
  viewBox: "0 0 14 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#FDC526",
  d: "M1 1v9h12V1M1 1h12M1 1l6 4.5L13 1"
})));
export { SvgIcLetter as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxNCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMVYxMEgxM1YxTTEgMUgxM00xIDFMNyA1LjVMMTMgMSIgc3Ryb2tlPSIjRkRDNTI2Ii8+Cjwvc3ZnPgo=";